// extracted by mini-css-extract-plugin
export default {"modal":"sy","topline":"ty","img":"uy","textcontents":"vy","heading":"wy","copy":"xy","link":"yy","close":"zy","modalinner":"Ay","container":"By"};
    if(module.hot) {
      // 1737143654562
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  